//#region IMPORTS
import { TableCellsIcon } from "@heroicons/react/24/outline";
import { Fragment } from "react";
import { Tooltip } from "react-tooltip";
import { InstoreOrder } from "../../models/instoreOrder";
import classNames from "../../helpers/classNames";
//#endregion

//#region INTERFACE
interface Props {
  downloadHandler: () => void;
  instoreOrder: InstoreOrder;
  disabled?: boolean;
  hide?: boolean;
}
//#endregion

export default function InstoreOrdersTableRowActionDownloadExcel({
  downloadHandler,
  instoreOrder,
  disabled = false,
  hide = false,
}: Props) {
  //#region RENDER
  // The tooltip anchor sits on a wrapper span: a disabled button swallows
  // hover events, and the disabled state is exactly when the tooltip matters.
  return !hide ? (
    <Fragment>
      <span
        data-tooltip-content={
          disabled ? "Not available when status is Ordered" : "Download Excel"
        }
        data-tooltip-variant="dark"
        data-tooltip-place="right"
        data-tooltip-id={String(instoreOrder.id) + "downloadExcel"}
        data-tooltip-delay-show={500}
        className={classNames(
          disabled ? "cursor-not-allowed" : "",
          "flex items-center",
        )}
      >
        <button
          type="button"
          onClick={downloadHandler}
          disabled={disabled}
          className="flex items-center disabled:pointer-events-none"
        >
          <TableCellsIcon
            className={classNames(
              disabled ? "text-gray-300" : "text-sky-600 hover:text-sky-500",
              "w-4 h-4",
            )}
          />
        </button>
      </span>
      <Tooltip id={String(instoreOrder.id) + "downloadExcel"} />
    </Fragment>
  ) : null;
  //#endregion
}
